<template>
  <div class="mc-readonly-list">
    <div v-for="item in items" :key="item.key || item.label" class="mc-readonly">
      <div class="mc-readonly__label">
        {{ item.label }}
      </div>
      <div :class="`mc-readonly__value${item.bold ? '-bold' : ''}`">
        <McBadge
          v-if="item.status"
          :text="item.value"
          :variant="item.status"
          type="status"
        />
        <router-link
          v-else-if="item.to"
          class="mc-readonly__link"
          :to="item.to"
          :data-me="item.dataMe"
        >
          {{ item.value }}
        </router-link>
        <template v-else>
          {{ item.value }}
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import McBadge from '@/components/McBadge'

export default {
  components: {
    McBadge,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style lang="scss">
.mc-readonly-list {
  display: flex;
  flex-wrap: wrap;
  gap: 16px 40px;
}

.mc-readonly {
  &__label {
    // Secondary/Navy/Navy 40
    color: $mep-color-text-200;
  }

  &__value {
    // Secondary/Navy/Navy 60
    color: $mep-color-text-300;
    display: flex;
    align-items: center;
    gap: 6px;
  }
  &__value-bold {
    // Secondary/Navy/Navy 80
    color: $mep-color-text-400;
    font-weight: 600;
  }

  &__link {
    color: $primary;
    font-weight: 600;

    &:hover {
      color: $primary;
      text-decoration: underline;
    }
  }
}
</style>
